export default axios => ({
  current() {
    return axios.get(`session/current`);
  },
  getDepartments(type, payload) {
    return axios.get(`department/${type}`, payload);
  },
  sendCode(payload) {
    return axios.post('session/user/send/code', payload);
  },
  open(session_id, payload) {
    return axios.post(`session/${session_id}/open`, payload);
  },
  close(session_id, payload) {
    return axios.post(`session/${session_id}/close`, payload);
  },
  getDevices(session_id) {
    return axios.get(`/session/${session_id}/device`)
  },
  visitContinue(payload) {
    return axios.post(`/session/visit/continue`, payload)
  },
  getPoll(session_id) {
    return axios.get(`/session/${session_id}/visit/poll/tag`)
  },
  sendPoll(session_id, payload) {
    return axios.post(`/session/${session_id}/visit/poll/tag`, payload)
  }

})
